const languageDir = {
  ltr: "ltr",
  rtl: "rtl",
};

export default languageDir;
